import { Heading4 } from '../Text';

import style from './post-aside-title.module.css';

interface PostAsideTitleProps {
  children: string;
}

const PostAsideTitle = ({
  children,
}: PostAsideTitleProps) => {
  return (
    <Heading4
      className={style.postAsideTitle}
      uppercase
    >
      {children}
    </Heading4>
  );
};

export default PostAsideTitle;
